type DiagnosticRecorder = (
  category: 'http.failure',
  data: Record<string, unknown>,
) => void;

let recorder: DiagnosticRecorder | undefined;

export function registerPlanningDiagnosticRecorder(value: DiagnosticRecorder): void {
  recorder = value;
}

export function recordPlanningHttpFailure(data: Record<string, unknown>): void {
  try {
    recorder?.('http.failure', data);
  } catch {
    // Diagnostics must never break an HTTP request or its error propagation.
  }
}
